import { AxiosResponse } from "axios";
import { camelizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { PaginatedResults } from "types/Query";
import { Publications } from "../publications";

const getApps = (): Promise<AxiosResponse<PaginatedResults<Publications.App>>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/application/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<PaginatedResults<Publications.AppApi>>) => {
    return {
      ...data,
      data: {
        ...data.data,
        results: data.data.results.map(camelizeObject<Publications.App>),
      },
    };
  });
};

const getApp = (id: number | string): Promise<AxiosResponse<Publications.App>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/application/${id}/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<Publications.AppApi>) => {
    return camelizeObject(data);
  });
};

const publishSurvey = (
  appId: number | string,
  surveyId: number | string
): Promise<AxiosResponse<Publications.Publication>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/application/${appId}/publication/`,
      method: "POST",
      data: { survey: surveyId },
    },
  }).then((data: AxiosResponse<Publications.PublicationApi>) => {
    return camelizeObject(data);
  });
};

const unpublishSurvey = (appId: number | string, publicationId: number | string) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/application/${appId}/publication/${publicationId}/`,
      method: "DELETE",
    },
  });
};

export const publicationsClient = {
  getApps,
  getApp,
  publishSurvey,
  unpublishSurvey,
};
